import { useEffect, useState } from "react";

import { Destination } from "Constant/destination";

import { TWITTER_TYPES } from "../DestinationCreation.constants";

const useTwitterAccount = () => {
    const [showCreateForm, setShowCreateForm] = useState(false);
    const [pixelId, setPixelId] = useState("");
    const [installId, setInstallId] = useState("");
    const [accountId, setAccountId] = useState("");

    const reset = () => {
        setShowCreateForm(false);
        setPixelId("");
        setInstallId("");
        setAccountId("");
    };

    return {
        reset,
        showCreateForm,
        setShowCreateForm,
        pixelId,
        setPixelId,
        installId,
        setInstallId,
        accountId,
        setAccountId,
    };
};

/**
 * X (Twitter) CAPI / Pixel: OAuth popup fills `oauthData`, then
 * `TwitterCreateDest` reports the selected pixel, install and account.
 */
const useTwitterDestination = ({
    destinationCode,
    oauthData,
    setSaveDisabled,
}) => {
    const capi = useTwitterAccount();
    const pixel = useTwitterAccount();

    useEffect(() => {
        if (oauthData && destinationCode === Destination.twcapi) {
            capi.setShowCreateForm(true);
        }
        if (TWITTER_TYPES.includes(destinationCode)) {
            setSaveDisabled(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [oauthData]);

    useEffect(() => {
        if (oauthData && destinationCode === Destination.twpixel) {
            pixel.setShowCreateForm(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [oauthData]);

    const activeAccount = destinationCode === Destination.twcapi ? capi : pixel;

    const getCreatePayload = () => ({
        pixel_id: activeAccount.pixelId,
        partner_install_id: activeAccount.installId,
        account_id: activeAccount.accountId,
    });

    const reset = () => {
        capi.reset();
        pixel.reset();
    };

    return { capi, pixel, activeAccount, getCreatePayload, reset };
};

export default useTwitterDestination;
